import * as React from 'react';
import { Grid, StyledComponentProps, Typography, Checkbox } from '@material-ui/core';
import TextField from '../../../ui-components/TextField/TextField';
import { subscription, SUBSCRIPTIONTYPES, subscriptionRules, days } from '../../../model/subscription';
import { Select, SelectItem } from '../../../ui-components/select/Select';
import { DayRow } from './DayRow';
import SaveIconButton from '../../../ui-components/Button/SaveIconButton';
import DatePicker from '../../../ui-components/DatePicker/DatePicker';

interface IProps extends StyledComponentProps {
    subscription: subscription;
    isLoading: boolean;
    saveSubscription: (subscription: subscription, rules: subscriptionRules) => any;
}

export const Subscription = (props: IProps) => {
    const [subscription, setSubscription] = React.useState<subscription>(props.subscription);
    const [selectedDays, setSelectedDays] = React.useState<subscriptionRules>(props.subscription?.subscriptionRules);

    // handleIsActive = (checked: boolean) => {
    //     this.setState({subscription: {...this.state.subscription, isActive: checked}});
    // }
    // addContactItem = () => {
    //     this.setState({subscription: {...this.state.subscription, contactList: [...this.state.subscription.contactList, '']}});
    // }
    // setContactListItem = (item: any, idx: any) => {
    //     this.state.subscription.contactList[idx] = item;
    //     this.setState({subscription: {...this.state.subscription, contactList: [...this.state.subscription.contactList]}});
    // }
    // deleteContactListItem = (idx: any) => {
    //     var array = [...this.state.subscription.contactList]; // make a separate copy of the array
    //     array.splice(idx, 1);
    //     this.setState({subscription: {...this.state.subscription, contactList: array}});
    // }
    const setSubscriptionType = (item) => {
        // var m = subscription.monthToBuy
        // var a = subscription.accessToBuy;
        // console.log("-------------------------------x-x-x-x-x-x-x----------------------");
        // console.log(item);
        setSubscription({ ...subscription, subscriptionType: item.value, monthToBuy: 0, accessToBuy: 0 });
    }
    const setTime = (day, openingDetails) => {
        // var m = subscription.monthToBuy
        // var a = subscription.accessToBuy;
        // console.log("----t-i-m-e------------------------x-x-x-x-x-x-x----------------------");
        // console.log(day);
        // console.log(openingDetails);
        setSelectedDays({ ...selectedDays, [day]: openingDetails });
        // setSubscription({ ...subscription, subscriptionRules: selectedDays});
        // setSubscription({ ...subscription, subscriptionType: item.value, monthToBuy: 0, accessToBuy: 0  });
    }

    const getSubscriptionItem = (subscription: subscription) => {
        // console.log("------------------- getSubscriptionItem----");
        var i: SelectItem = { name: '', value: '' };
        if (subscription && subscription.subscriptionType && subscription.subscriptionType) {
            // console.log(subscription.subscriptionType);
            i = { name: SUBSCRIPTIONTYPES[subscription.subscriptionType].title, value: subscription.subscriptionType };
        }
        return i;
    }

    if (subscription?._id !== props.subscription?._id) {
        // controllo se la props è cambiata           
        // console.log("----y-y-y-y-y-y---------------------");
        // console.log(subscription?._id);
        // console.log(props.subscription?._id);
        // this.setState({subscription: this.props.subscription });
        setSubscription(props.subscription);
        setSelectedDays(props.subscription?.subscriptionRules);
        // if (props.subscription?._id == '0') {
        //     setSubscription({ ...subscription, _id: undefined });
        // }
    }
    const subscriptionTypes = Object.keys(SUBSCRIPTIONTYPES);
    // .filter(key => !isNaN(Number(SUBSCRIPTIONTYPES[key])));
    // if (subscription?.subscriptionType == undefined) {
    //     // IMPOSTO IL DEFAULT
    //     setSubscriptionType({name:subscriptionTypes["MONTHLY"].name, value: "MONTHLY"});
    // }
    // console.log("OKKIO--------------------------------------");
    // console.log(subscription);
    // console.log(props.isLoading);
    return (subscription ?
        <Grid container spacing={2}>
            <Grid item sm={10} className={props.classes.nameSurnameContainer}>
                {/* <Grid container spacing={1}> */}
                    <Grid item sm={12}>
                        <TextField
                            label="Nome"
                            onChange={(val) => setSubscription({ ...subscription, subscriptionName: val })}
                            value={subscription.subscriptionName}
                        />
                    </Grid>
                    <Grid item sm={12} >
                        <Select fullWidth
                            selected={getSubscriptionItem(subscription)}
                            // selected={subscription && subscription.subscriptionType && subscription.subscriptionType !== undefined  ? 
                            //     { name: SUBSCRIPTIONTYPES[subscription.subscriptionType], value: subscription.subscriptionType } : 
                            //     { name: "", value: ""}}
                            items={subscriptionTypes.map(t => {
                                // console.log("----------------------------------------------" + SUBSCRIPTIONTYPES.MENSILE.code);
                                // console.log("---" + SUBSCRIPTIONTYPES[t].title);    // Mensile
                                // console.log(t);                                     // MENSILE
                                return { name: SUBSCRIPTIONTYPES[t].title, value: t }
                            })}
                            onChange={(item) => setSubscriptionType(item)} label='Seleziona un tipo' />
                    </Grid>
                    <Grid item sm={12}>
                        <TextField type={"number"}
                            disabled={subscription?.subscriptionType !== SUBSCRIPTIONTYPES.MENSILE.code}
                            label="Mesi"
                            onChange={(val) => setSubscription({ ...subscription, monthToBuy: Number(val) })}
                            value={subscription.monthToBuy.toString()}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <TextField type={"number"}
                            disabled={subscription?.subscriptionType !== SUBSCRIPTIONTYPES.ACCESSI.code}
                            label="Accessi"
                            onChange={(val) => setSubscription({ ...subscription, accessToBuy: Number(val) })}
                            value={subscription.accessToBuy.toString()}
                        />
                    </Grid>
                    <Grid item sm={12} style={{ display: 'flex' }}>
                        <Checkbox
                            checked={subscription?.accessToActivities}
                            title='Accesso alle attività'
                            onChange={(e, val) => setSubscription({ ...subscription, accessToActivities: val })}
                        />
                        <Typography style={{ margin: '10px' }}>Accesso alle attività {subscription.accessToActivities ? 'OK' : 'NON PERMESSO'}</Typography>
                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            label="Note"
                            onChange={(val) => setSubscription({ ...subscription, notes: val })}
                            value={subscription.notes}
                        />
                    </Grid>
                    {days.map((day, idx) => <DayRow key={'subscription-day-' + idx} classes={props.classes}
                        day={day}
                        value={selectedDays[day.value]}
                        onchange={openingDetails => setTime(day.value, openingDetails)}
                    />)}
                    <Grid item sm={12}>
                        <DatePicker
                            key={`newActivityDefinition-from-date-picker`}
                            label="Data fine validità"
                            fullWidth
                            //disabled={true}
                            minDate={new Date()}
                            value={subscription.expiresOn}
                            onChange={(d) => setSubscription({ ...subscription, expiresOn: d })}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <SaveIconButton onClick={() => props.saveSubscription(subscription, selectedDays)} />
                    </Grid>
                {/* </Grid> */}
            </Grid>
        </Grid> : <></>
    )

}
